import PageBanner from "@/components/feature/PageBanner";
import { useApi } from "@/hooks/useApi";
import type { DocItem } from "@/lib/types";
import { Skeleton } from "@/components/base/Skeleton";
import EmptyState from "@/components/base/EmptyState";
import RuleCard from "@/components/feature/rules/RuleCard";

// /rules — 규정 3종(정관 · 세칙 · 상조회칙) 목록
export default function RulesPage() {
  const { data, loading, error, reload } = useApi<DocItem[]>("docs.php");
  const docs = data ?? [];

  return (
    <>
      <PageBanner
        title="규정"
        description="대전민들레로타리클럽의 정관 · 세칙 · 상조회칙 전문을 안내합니다."
        breadcrumb={[{ label: "규정" }]}
      />

      <section className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        {loading ? (
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-56 w-full rounded-xl" />
            ))}
          </div>
        ) : error ? (
          <EmptyState
            icon="ri-error-warning-line"
            title="규정을 불러오지 못했습니다"
            description={error}
            action={
              <button
                type="button"
                onClick={reload}
                className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                다시 시도
              </button>
            }
          />
        ) : docs.length === 0 ? (
          <EmptyState icon="ri-file-text-line" title="등록된 규정이 없습니다" />
        ) : (
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {docs.map((doc) => (
              <RuleCard key={doc.code} doc={doc} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}